export enum LanguageSupportedLocale {
	en = "en",
	nl = "nl",
	de = "de",
	fr = "fr",
	es = "es",
	it = "it",
}
